import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useNotificationPreferences = () => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("users/me/notification-preferences");
		return res.data?.data;
	};

	return useQuery(["notification-preferences"], () => fetch(), {
		...fetchConfig,
	});
};

export default useNotificationPreferences;
